<template>
  <div class="chat-page" id="chat-page">
    <!-- 遮罩层 -->
    <div
      class="mask"
      v-if="showInput"
      @touchmove.prevent.stop="bindTouchmove"
      @mounsemove.prevent.stop="bindTouchmove"
      @click.stop="hideEmojiIcon"
    ></div>
    <div class="chat-content" @click.stop="bindShowInput">
      <div class="chat-box" v-if="!showInput">
        <div class="input-text" @click.stop="bindShowInput">
          <i class="iconfont icon-home_tab_message"></i>
          <span>评论点什么吧...</span>
        </div>
        <div class="chat-right">
          <div class="chaticon collect" @click.stop="collectDynamic">
            <i
              class="iconfont icon-shoucang1"
              :class="{ 'like-active': articleInfo.is_save === 0 }"
            ></i>
            <div class="iconfont-count">{{ articleInfo.save_num || 0 }}</div>
          </div>
          <div class="chaticon like" @click.stop="likeDynamic">
            <i
              class="iconfont icon-dianzan_kuai"
              :class="{ 'like-active': articleInfo.is_useful }"
            ></i>
            <div class="iconfont-count">{{ articleInfo.useful || 0 }}</div>
          </div>
        </div>
      </div>
      <div class="chat-box" v-else>
        <van-field
          ref="textarea"
          class="chat-input"
          maxlength="2000"
          v-model="inputValue"
          type="textarea"
          @focus="bindFocus"
          @blur="bindBlur"
          :clearable="true"
          :autosize="autosize"
          :placeholder="
            chatInfo.user_name ? '@' + chatInfo.user_name : '写点什么吧！'
          "
        />
        <div class="chat-right">
          <!--  <div class="emoji-icon iconfont icon-biaoqing" @click.stop="toggleEmojiContent"></div> -->
          <div
            class="send"
            v-if="inputValue !== ''"
            @click.stop="commentDynamic"
          >
            发送
          </div>
        </div>
      </div>
      <!-- 表情列表 -->
      <!--  <wegymer-emoji-list v-if="{{showEmojiList}}" bindclick="addEmoji"></wegymer-emoji-list> -->
    </div>
  </div>
</template>
<script>
export default {
  props: {
    chatInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    articleInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    placeholder: {
      type: String,
      default: '写点什么吧!'
    },
    //是否聚焦输入框
    focus: {
      type: Boolean,
      default: false
    },
    toId: {
      type: Number,
      default: 0
    },
    toUnifyId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      autosize: {
        maxHeight: 60,
        minHeight: 20
      },
      positionMethods: 'fixed',
      maxLength: 2000, //最大评论文字
      textAreaHeight: 140,
      inputOffsetBottom: 1000,
      autoHeight: false,
      showEmojiList: false, //是否显示表情列表
      showInput: false, //是否显示输入框
      inputValue: '' //用户输入的文字
    }
  },
  watch: {
    showInput(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.textarea.focus()
          // document.getElementsByTagName('textarea')[0].focus();
        })
      }
    }
  },
  mounted() {},
  methods: {
    bindTouchmove() {},
    //收藏
    collectDynamic() {
      this.$emit('collect')
    },
    //点赞动态
    likeDynamic(e) {
      this.$emit('like')
    },
    //修改Placeholder的值
    changePlaceholder() {},
    //隐藏表情按钮
    hideEmojiIcon() {
      console.log('隐藏')
      this.bindHideInput()
      this.$emit('resetUser')
    },
    //评论动态
    commentDynamic() {
      this.$emit('comment', this.inputValue)
      this.hideEmojiIcon()
      this.clearInput()
    },
    bindBlur() {
      setTimeout(() => {
        window.scrollTo(0, this.scrollTop)
      }, 100)
    },
    bindFocus() {
      this.scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop || 0
      /* setTimeout(()=>{
        window.scrollTo(0,this.scrollTop);
        },200); */
    },
    bindShowInput() {
      this.showInput = true
    },
    bindHideInput() {
      this.showInput = false
    },
    clearInput() {
      this.inputValue = ''
    },
    toggleEmojiContent() {
      this.setData({
        showEmojiList: !this.data.showEmojiList
      })
    }
  }
}
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(207, 192, 192, 0.1);
  z-index: 1;
}
.chat-content {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 10;
  width: 100%;
  padding: 2.7vw 0vw 5.3vw;
  background-color: #fff;
  border: 0.5vw solid #f7f7f7;
}
.chat-box {
  padding: 0vw 2.7vw 1.3vw;
  display: flex;
  align-items: center;
  background-color: #fff;
  box-sizing: border-box;
}
.chat-right {
  font-size: 2.7vw;
  display: flex;
  align-items: center;
}
.input-text {
  flex: 1;
  display: flex;
  align-items: center;
  margin-right: 4vw;
  height: 9.3vw;
  background-color: #f1f1f1;
  border-radius: 4.7vw;
  padding-left: 5.3vw;
  font-size: 3.2vw;
  color: rgba(0, 0, 0, 0.5);
}
.input-text .iconfont {
  color: rgba(0, 0, 0, 0.19);
  margin-right: 1.3vw;
}
.chat-input {
  padding: 2.7vw 5.3vw;
  box-sizing: border-box;
  height: auto;
  flex: 1;
  margin-right: 4vw;
  line-height: 4vw;
  min-height: 9.3vw;
  max-height: 26.7vw;
  background-color: #f1f1f1;
  border-radius: 3.7vw;
  font-size: 3.2vw;
  color: rgba(0, 0, 0, 0.5);
}
.send {
  margin-left: 5.3vw;
  height: 8vw;
  line-height: 8vw;
  padding: 0vw 2.7vw;
  background: #e50049;
  font-weight: 600;
  font-size: 3.5vw;
  color: #fff;
  border-radius: 4.7vw;
}
.like,
.attention,
.forward {
  margin-right: 2.7vw;
  display: flex;
  align-items: center;
}
.chaticon {
  padding: 0vw 3.7vw;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.chaticon .iconfont {
  margin-bottom: 1.8vw;
  color: #ccc;
}
.collect .like-active {
  color: #f7b500;
}
.like .like-active {
  color: #2882e9;
}
.forward .iconfont {
  font-size: 5.3vw;
}
.chat-right .icon-xihuanlike {
  color: #e50049;
}
.zan-content {
  width: 6.7vw;
  height: 6.7vw;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1.1vw;
  position: relative;
}
.icon-xinxing {
  color: rgb(197, 197, 197);
  font-size: 4vw;
}
.like-active {
  color: rgb(240, 70, 70);
}
.icon-biaoqing {
  font-size: 6.7vw;
}
.zan-content,
.like-content {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.iconfont-count {
  font-size: 2.7vw;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.5);
  line-height: 3.7vw;
}
</style>
